import React, { Component } from "react";
import { connect } from "react-redux";
import { logOut } from "../../store/actions/customer";
import { Link } from "react-router-dom";
import Widget from "../../components/shared/Widget";
import styles from "../../thema/style";
import { withRouter } from "react-router";
import calculatePrice from "../../helpers/calculatePrice";
import activeDiscount from "../../helpers/activeDiscount";

class CartWidget extends Component {
  render() {
    const cartTotalDiscountPrice =
      this.props.cart.items.length > 0
        ? parseFloat(
            this.props.cart.items
              .map((product) =>
                parseFloat(
                  calculatePrice(product, activeDiscount(product.categories))
                )
              )
              .reduce((a, b) => a + b)
              .toFixed(2)
          )
        : 0;

    const cartTotalPrice =
      this.props.cart.items.length > 0
        ? parseFloat(
            this.props.cart.items
              .map((item) =>
                item.sale_price
                  ? item.quantity * item.sale_price
                  : item.quantity * item.price
              )
              .reduce((a, b) => a + b)
              .toFixed(2)
          )
        : 0;

    return (
      this.props.cart.items.length > 0 && (
        <Widget title={"SEPETİM"}>
          <div className={styles.orderSummary}>
            <ul>
              <li>
                <strong>
                  Toplam{" "}
                  {this.props.cart.items.length > 0
                    ? this.props.cart.items
                        .map((v) => v.quantity)
                        .reduce((a, b) => a + b)
                    : 0}{" "}
                  Ürün
                </strong>
              </li>
              <li>
                Ara Toplam:
                <span> ₺{parseFloat(cartTotalPrice).toFixed(2)}</span>
              </li>

              {cartTotalDiscountPrice > 0 ? (
                <li>
                  Kargo:
                  <span>
                    ₺
                    {parseFloat(
                      this.props.setting.setting.shipping_cost
                    ).toFixed(2)}
                  </span>
                </li>
              ) : null}

              {cartTotalDiscountPrice >=
              this.props.setting.setting.free_shipping ? (
                <li style={{ display: "flex", flexDirection: "column" }}>
                  {parseFloat(this.props.setting.setting.free_shipping).toFixed(
                    2
                  )}{" "}
                  TL ve Üzeri Ücretsiz Kargo:
                  <span style={{ color: "#c00", alignSelf: "flex-end" }}>
                    -₺
                    {parseFloat(
                      this.props.setting.setting.shipping_cost
                    ).toFixed(2)}
                  </span>
                </li>
              ) : null}

              {cartTotalPrice - cartTotalDiscountPrice > 0 ? (
                <li>
                  Sepette İndirim:
                  <span style={{ color: "#c00" }}>
                    -₺
                    {parseFloat(
                      cartTotalPrice - cartTotalDiscountPrice
                    ).toFixed(2)}
                  </span>
                </li>
              ) : null}

              {/* {cartTotalPrice > 0 ? (
                <li>
                  Kargo
                  <span> ₺{this.props.setting.setting.shipping_cost}</span>
                </li>
              ) : null} */}

              <li className={"sperator"} />
              <li>
                Toplam
                <span>
                  {parseFloat(
                    cartTotalDiscountPrice > 0
                      ? cartTotalDiscountPrice +
                          (cartTotalDiscountPrice >=
                          this.props.setting.setting.free_shipping
                            ? 0
                            : this.props.setting.setting.shipping_cost)
                      : 0
                  ).toFixed(2)}
                </span>
              </li>
            </ul>
            <div className={"text-right"}>
              <button
                onClick={(e) => {
                  e.preventDefault();

                  this.props.history.push({ pathname: "/sepet" });
                }}
                type={"button"}
              >
                Sepet Detayına Git
              </button>
            </div>
          </div>
        </Widget>
      )
    );
  }
}

const mapStateToProps = ({ cart, customer, setting }) => {
  return { cart, customer, setting };
};

const mapDispatchToProps = {};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CartWidget)
);



// WEBPACK FOOTER //
// ./src/components/shared/CartWidget.js